import React from 'react'
import { useTranslation } from 'react-i18next'
import { KibToggle } from '@chewy/kib-controls-react'
import { KibOpenFullscreenIcon } from '@chewy/kib-icons-react'
import { KibGrid, KibGridItem } from '@chewy/kib-layout-react'
import classNames from 'classnames'

import CommunicationFilter from './CommunicationFilter'

import '@chewy/kib-layout-styles/dist/styles/kib-grid.css'
import '@chewy/kib-controls-styles/dist/styles/kib-toggle.css'
import styles from './SnapshotHeader.module.scss'

const SnapshotHeader = ({
  isExpanded,
  name,
  showNoItems,
  onExpand,
}: {
  isExpanded?: boolean
  name: string
  onExpand: () => void
  showNoItems: boolean
}) => {
  const { t } = useTranslation(['Clients'])
  if (isExpanded) {
    return null
  }
  return (
    <KibGrid
      className={classNames(styles.communicationSnapshotHeader, {
        [styles.bottomBorder]: showNoItems,
      })}
      valign="center"
    >
      <KibGridItem>{name}</KibGridItem>
      <KibGridItem>
        <CommunicationFilter />
        <KibToggle
          ariaLabel={t('Clients:COMMUNICATION_WIDGET.EXPAND_FULLSCREEN')}
          ariaLabelSelected={t('Clients:COMMUNICATION_WIDGET.CLOSE_FULLSCREEN')}
          icon={<KibOpenFullscreenIcon />}
          size="medium"
          theme="utility"
          onClick={onExpand}
        />
      </KibGridItem>
    </KibGrid>
  )
}
export default SnapshotHeader
